import { DistanceMeasurementsPlugin, DistanceMeasurementsMouseControl } from "@xeokit/xeokit-sdk";

let measurementPlugin = null;
let measurementControl = null;

export function measurementTool(viewer, enable) {
    if (!viewer) {
        console.error("Viewer is not initialized.");
        return;
    }
    if (!viewer.scene || !viewer.scene.models || Object.keys(viewer.scene.models).length === 0) {
        console.error("❌ No model loaded - Measurement Tool cannot be enabled.");
        return;
    }

    if (enable) {
        if (!measurementPlugin) {
            measurementPlugin = new DistanceMeasurementsPlugin(viewer);

            measurementPlugin.on("measurementStart", (measurement) => {
                console.log("Started Measurement", measurement);
            });

            measurementPlugin.on("measurementEnd", (measurement) => {
                console.log("Measurement Completed", measurement);
            });

            measurementPlugin.on("measurementCancel", (measurement) => {
                console.log("Measurement Canceled", measurement);
            });

            if (!measurementControl) {
                measurementControl = new DistanceMeasurementsMouseControl(measurementPlugin, {
                    snapping: true
                });

                measurementControl.snapping = true;
            }
        }
        // Enable the measurement tool
        measurementControl.activate(); 

    } else {
        //Disable measurement tool
        if (measurementControl) {
            measurementControl.deactivate();
        }

        if (measurementPlugin) {
            measurementPlugin.clear();
        }
    }
}